const getMonth = (dateString) => {
  const month = dateString ? new Date(dateString) : new Date();
  return new Date(
    month.getFullYear(),
    month.getMonth(),
    1,
    0,
    0,
    0,
    0
  ).getTime();
};

export default getMonth;
